
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import React from 'react';
import Zergling from '../../../helpers/zergling';
import moment from "moment";
import _ from 'lodash';
import Config from '../../../config/main';
class Result extends React.Component {
    constructor (props) {
        super();
        this._isMounted = false;
        this.state = {
            data: null,
            selectedSport: null,
            startDay: moment().startOf('day').toDate(),
            sportComps: null,
            isLoading: false,
            searchInput: false,
            inputText: '',
            filteredData: [],
            isFiltred: false,
            errMessage: false,
            dropDown: false
        };
        this.handleChangeDateFrom = this.handleChangeDateFrom.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.searchToggle = this.searchToggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setFirstGameId = this.setFirstGameId.bind(this);
        this.filterData = _.debounce(this.filterData, 2000);
        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.closeDropDown = this.closeDropDown.bind(this);
    }
    closeDropDown () {
        if (this.state.dropDown) {
            this.setState({ dropDown: false });
        }
    }
    toggleDropDown () {
        if (this.state.dropDown) {
            this.setState({ dropDown: false });
        } else {
            this.setState({ dropDown: true });
        }
    }
    filterData () {
        this.state.sportComps && Config.main.resultPageVirtualsId.includes(Number(this.state.selectedSport.Id))
            ? this.state.sportComps.filter((item) => item.round_id && (item.round_id + "").includes(this.state.inputText)
                ? this.setState({ filteredData: [item, ...this.state.filteredData], isFiltred: true }) : this.setState({ errMessage: true }))
            : this.state.sportComps && this.state.sportComps.filter((item) =>
                item.team1_name.toLowerCase().includes(this.state.inputText.toLowerCase()) ||
            item.team2_name.toLowerCase().includes(this.state.inputText.toLowerCase()) ||
            item.competition_name.toLowerCase().includes(this.state.inputText.toLowerCase()) || item.short_id.toString().includes(this.state.inputText.toLowerCase()) 
                    ? this.setState({ filteredData: [item, ...this.state.filteredData], isFiltred: true }) : this.setState({ errMessage: true }));
        if (this.state.inputText.length === 1) {
            this.setState({ filteredData: [], isFiltred: false, errMessage: false });
        }
    }
    handleChange (e) {
        this.setState({ inputText: e }, () =>
            this.state.inputText.length >= 1 && !this.state.isFiltred && this.filterData());
        if (!this.state.inputText) {
            this.setState({ filteredData: [], isFiltred: false, errMessage: false });
        }
        if (this.state.inputText.length === 1 && this.state.isFiltred) {
            this.setState({ filteredData: [], isFiltred: false, errMessage: false });
        }
        if (this.state.inputText.length === 1 && this.state.errMessage) {
            this.setState({ errMessage: false });
        }
    }

    handleChangeDateFrom (e) {
        if (this.state.searchInput) {
            this.setState({ searchInput: false, filteredData: [], isFiltred: false, errMessage: false });
        }
        const swarmDataKeyForActiveGames = "get_active_competitions",
            req = {
                'from_date': moment(e).startOf('day').unix(),
                'to_date': moment(e).endOf('day').unix() - 60
            };
        Zergling.get(req, swarmDataKeyForActiveGames).then((resp) => { this.setState({ data: resp.details.sort((a, b) => a.Id - b.Id) }); });
        const swarmDataKey = "get_result_games";
        this.setState({ startDay: moment(e).startOf('day').toDate(), isLoading: true, dropDown: false }, () => {
            let request = {
                'from_date': moment(e).startOf('day').unix(),
                'to_date': moment(e).endOf('day').unix() - 60,
                'sport_id': this.state.selectedSport.Id ? this.state.selectedSport.Id : this.state.data[0].Id
            };
            Zergling.get(request, swarmDataKey).then((resp) => resp.games.game.length === 0 ? this.setFirstGameId() : this.setState({ sportComps: resp.games.game, isLoading: false }));
        });
    }
    searchToggle () {
        if (this.state.searchInput) {
            this.setState({ searchInput: false, filteredData: [], isFiltred: false, errMessage: false });
        } else {
            this.setState({ searchInput: true });
        }
    }
    handleChangeSelect (item) {
        if (this.state.searchInput) {
            this.setState({ searchInput: false, filteredData: [], isFiltred: false, errMessage: false });
        }
        const swarmDataKey = "get_result_games";
        this.setState({ selectedSport: item, isLoading: true, dropDown: false }, () => {
            let request = {
                'from_date': moment(this.state.startDay).unix(),
                'to_date': moment(this.state.startDay).unix() + 86340,
                'sport_id': this.state.selectedSport.Id ? this.state.selectedSport.Id : item.Id
            };
            Zergling.get(request, swarmDataKey).then((resp) => this.setState({ sportComps: resp.games.game, isLoading: false }));
        });
    }
    setFirstGameId () {
        const swarmDataKeyForSport = "get_result_games";
        let req = {
            'from_date': this.state.startDay ? moment(this.state.startDay).unix() : moment().startOf("day").unix(),
            'to_date': this.state.startDay ? moment(this.state.startDay).unix() + 86340 : moment().endOf("day").unix() - 160,
            'sport_id': 1
        };
        Zergling.get(req, swarmDataKeyForSport).then((response) => this.setState({ sportComps: response.games.game, sport_id: 1, isLoading: false }));
    }
    getSportList (selectedGame) {
        const swarmDataKeyForSport = "get_result_games";
        let req = {
            'from_date': this.state.startDay ? moment(this.state.startDay).unix() : moment().startOf("day").unix(),
            'to_date': this.state.startDay ? moment(this.state.startDay).unix() + 86340 : moment().endOf("day").unix(),
            'sport_id': this.state.selectedSport.Id ? this.state.selectedSport.Id : selectedGame.Id
        };
        Zergling.get(req, swarmDataKeyForSport).then((response) => this.setState({ sportComps: response.games.game, selectedSport: selectedGame }));
    }
    componentDidMount () {
        this._isMounted = true;
        const swarmDataKeyForActiveGames = "get_active_competitions",
            request = {
                'from_date': moment().startOf("day").unix(),
                'to_date': moment().endOf("day").unix()
            };
        Zergling.get(request, swarmDataKeyForActiveGames).then((resp) => { this._isMounted && this.setState({ data: resp.details.sort((a, b) => a.Id - b.Id) }, () => this._isMounted && this.setState({ selectedSport: {Id: this.state.data[0].Id, Name: this.state.data[0].Name} })); this._isMounted && this.getSportList(this.state.selectedSport); });
    }
    componentWillUnmount () {
        this._isMounted = false;
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
export default Result;